// src/Redux/selectors/rendezvousSelectors.js

/** Racine */
export const selectRendezvousState = (state) => state.rendezvous;

/** Collection complète */
export const selectAllRendezvous = (state) =>
  state.rendezvous.items || [];

/** Chargement / erreur global fetch-all */
export const selectRendezvousLoading = (state) =>
  state.rendezvous.fetching;

export const selectRendezvousError = (state) =>
  state.rendezvous.fetchError;

/** Création */
export const selectRendezvousCreating = (state) =>
  state.rendezvous.creating;

export const selectRendezvousCreateError = (state) =>
  state.rendezvous.createError;

export const selectRendezvousLastCreated = (state) =>
  state.rendezvous.lastCreated;

/** Par ID */
export const selectRendezvousById = (state, id) =>
  (state.rendezvous.items || []).find((r) => String(r.id) === String(id));

/** Scopes dérivés (médecin / patient / états) */
export const selectRdvByMedecin = (state) => state.rendezvous.byMedecin.items;
export const selectRdvByMedecinLoading = (state) => state.rendezvous.byMedecin.loading;
export const selectRdvByMedecinError = (state) => state.rendezvous.byMedecin.error;

export const selectRdvByPatient = (state) => state.rendezvous.byPatient.items;
export const selectRdvByPatientLoading = (state) => state.rendezvous.byPatient.loading;
export const selectRdvByPatientError = (state) => state.rendezvous.byPatient.error;

export const selectRdvConfirmed = (state) => state.rendezvous.confirmed.items;
export const selectRdvConfirmedLoading = (state) => state.rendezvous.confirmed.loading;
export const selectRdvConfirmedError = (state) => state.rendezvous.confirmed.error;

export const selectRdvScheduled = (state) => state.rendezvous.scheduled.items;
export const selectRdvScheduledLoading = (state) => state.rendezvous.scheduled.loading;
export const selectRdvScheduledError = (state) => state.rendezvous.scheduled.error;

export const selectRdvRescheduled = (state) => state.rendezvous.rescheduled.items;
export const selectRdvRescheduledLoading = (state) => state.rendezvous.rescheduled.loading;
export const selectRdvRescheduledError = (state) => state.rendezvous.rescheduled.error;

/** Exemple de résumé (si un jour tu ajoutes summaries dans le slice) */
export const selectRendezvousSummary = (state, userId, period) =>
  state.rendezvous.summaries?.[userId]?.[period] || {
    confirmed: [],
    scheduled: [],
    rescheduled: [],
  };
// ✅ NEW — à ajouter à la fin du fichier existant
export const selectRdvRescheduling = (state) =>
  state.rendezvous?.rescheduling ?? false;

export const selectRdvRescheduleError = (state) =>
  state.rendezvous?.rescheduleError ?? null;